mcWeb.shipment = jQuery.extend(mcWeb.shipment, new function () {

    this.vm = function (id) {
        var $ = jQuery;
        var self = this;

        self.id = "#" + id;
        self.service = new WebApiService("Shipment");

        self.showShipments = ko.observable(false);
        self.hasCartItems = ko.observable(false);
        self.showShipmentsDetails = ko.observable(true);

        self.showShipmentPrice = ko.observable(false);
        self.showOnlyCarrierList = ko.observable();
        self.showCheckoutZipCode = ko.observable(true);
        self.selectedCarrierName = ko.observable();
        self.noCarrierSelected = ko.computed(function () {
            return (!self.selectedCarrierName());
        });
        self.carrierList = ko.observableArray();
        self.carrierListVisible = ko.observable(false);
        self.selectedCarrierId = ko.observable();
        self.selectedCarrierPrice = ko.observable();

        self.logistraPickupPointsForSelectedCarrier = ko.observableArray();
        self.selectedLogistraPickupPoint = ko.observable();
        self.selectedLogistraPickupPointData = ko.computed(function () {
            if (self.logistraPickupPointsForSelectedCarrier() == null)
                return null;
            
            if (self.logistraPickupPointsForSelectedCarrier().length < 1)
                return null;
            
            var id = self.selectedLogistraPickupPoint();
            var data = null;
            if (id == null)
                data = self.logistraPickupPointsForSelectedCarrier()[0];
            else 
                data = self.logistraPickupPointsForSelectedCarrier().find(obj => { return obj.Id === id });
            
            if (data == null)
                data = self.logistraPickupPointsForSelectedCarrier()[0];
            
            return {
                Id: data.Id,
                Name: data.Name,
                Address: data.Address,
                PostalCode: data.PostalCode,
                City: data.City,
                PhoneNumber: data.PhoneNumber,
                EmailAddress: data.EmailAddress
            };
        });

        self.shipAdvisorDropPointsForSelectedCarrier = ko.observableArray();
        self.selectedShipAdvisorDropPoint = ko.observable();
        self.selectedShipAdvisorDropPointData = ko.computed(function () {
            if (self.shipAdvisorDropPointsForSelectedCarrier() == null)                 
                return null;            
            
            if (self.shipAdvisorDropPointsForSelectedCarrier().length < 1) 
                return null;            
            
            var id = self.selectedShipAdvisorDropPoint();
            var data = null;
            if (id == null) 
                data = self.shipAdvisorDropPointsForSelectedCarrier()[0];
            else
                data = self.shipAdvisorDropPointsForSelectedCarrier().find(obj => { return obj.Id === id });
            
            if (data == null) 
                data = self.shipAdvisorDropPointsForSelectedCarrier()[0];
            
            return {
                Id: data.Id,
                Name: data.Name,
                Address: data.Address,
                PostalCode: data.PostalCode,
                City: data.City,
                PhoneNumber: data.PhoneNumber,
                EmailAddress: data.EmailAddress
            };
        });

        self.pickupPointEnabled = ko.observable(false);
        self.pickupPointRegionList = ko.observableArray();
        self.pickupPointCustomerList = ko.observableArray();
        self.pickupPointSelectedRegion = ko.observable();
        self.pickupPointSelectedCustomer = ko.observable();
        self.pickupPointRegion = ko.observable();
        self.pickupPointRegionId = ko.observable();
        self.pickupPointCustomername = ko.observable();
        self.popoverOpen = ko.observable(false);

        self.zipCodePrev = ko.observable();
        self.zipCode = ko.observable();
        self.focusZipCode = ko.observable(false);

        self.postOffice = ko.observable();
        self.adressDelivery = ko.observable();
        self.adresstillegDelivery = ko.observable();
        self.poststedDelivery = ko.observable();

        self.showRefreshSpin = ko.observable(false);
        self.showRefreshSpinMargin = ko.observable(0);
        self.isCheckout = ko.observable(false);
        self.inlineEditor = ko.observable(false);
        self.showCollectedDelivery = ko.observable(false);
        self.useCollectedDeliveryPrev = ko.observable(false);
        self.useCollectedDelivery = ko.observable(false);
        self.previousCarrierId = null;
        self.previousCarrierList = null;

        self.useCollectedDelivery.subscribe(function (newValue) {
            if (self.useCollectedDeliveryPrev() != newValue) {
                self.useCollectedDeliveryPrev(newValue);
                PubSub.publish(mcWeb.cart.events.onChangeCollectedDelivery, newValue);
            }
        });

        self.showInsuranceProduct = ko.observable(false);
        self.useInsuranceProduct = ko.observable(false);
        self.klarnaShippingAssistantEnabled = ko.observable(false);

        self.showPrintPackingList = ko.observable(false);
        self.usePrintPackingListPrev = ko.observable(false);
        self.usePrintPackingList = ko.observable(false);

        self.usePrintPackingList.subscribe(function (newValue) {
            if (self.usePrintPackingListPrev() !== newValue) {
                //self.usePrintPackingListPrev(newValue); //Denne skal IKKE være med
                PubSub.publish(mcWeb.events.customerRegistration.onChangedUsePrintPackingList, newValue);
            }
        });

        getLibrary("mcWeb.customerRegistration").then(() => {
            PubSub.subscribe(mcWeb.events.customerRegistration.onChangedUsePrintPackingList, function (message, active) {
                if (active === true || active === false) {
                    if (self.usePrintPackingList() !== active) {
                        self.usePrintPackingList(active);
                    } else {
                        self.usePrintPackingListPrev(active);
                    }
                }
            });
        });

        //Set the hight of "update icon"
        this.showRefreshSpin.subscribe(function () {
            var hight = parseFloat($("#carrier-selected.panel").height());
            if (hight != NaN && hight > 1) {
                self.showRefreshSpinMargin(((hight / 2) - 30) + 'px');
            }
        });

        this.load = function (data, settings) {

            self.showRefreshSpin(true);

            //Settings
            if (settings) {
                self.showShipments(settings.ShowShipments);
                self.showShipmentPrice(settings.ShowShipmentPrice);
                self.showOnlyCarrierList(settings.ShowOnlyCarrierList);
                self.showCheckoutZipCode(settings.ShowCheckoutZipCode);
                self.isCheckout(($('.body-checkout').length > 0) ? true : false);

                self.showCollectedDelivery(settings.ShowCollectedDelivery);
                self.showPrintPackingList(settings.ShowPrintPackingList);
                self.showInsuranceProduct(settings.ShowInsuranceProduct);
                self.inlineEditor(settings.InlineEditor);
            }

            //Loading data width ajax
            if (!data) {
                self.service.GetAction("CarrierList", { isCheckout: self.isCheckout() }).then(function (result) {
                    if (result == null) {
                        self.selectedCarrierName(undefined);
                        self.showRefreshSpin(false);
                        return;
                    }

                    self.load(result);
                });
                return;
            }

            self.pickupPointEnabled(data.PickupPointEnabled);
            if (data.CarrierList)
                self.carrierList(data.CarrierList);
            self.selectedCarrierId(data.SelectedCarrierId);
            setSelectedCarrier(data);
            if (self.zipCode() == null && self.zipCodePrev() == null) {
                self.zipCodePrev(data.ZipCode);
                self.zipCode(data.ZipCode);
            }

            self.useCollectedDeliveryPrev(data.UseCollectedDelivery);
            self.useCollectedDelivery(data.UseCollectedDelivery);

            self.useInsuranceProduct(data.UseInsuranceProduct);

            self.klarnaShippingAssistantEnabled(data.KlarnaShippingAssistantEnabled);
            self.showShipmentsDetails(!data.KlarnaShippingAssistantEnabled);

            self.usePrintPackingList(data.UsePrintPackingList);
            self.usePrintPackingListPrev(data.UsePrintPackingList); //Denne skal ligge neders pga event oppdatering

            self.showRefreshSpin(false);

            if (self.previousCarrierId == null) {
                PubSub.publish(mcWeb.shipment.events.onChangedShipment, data);
                self.previousCarrierId = self.selectedCarrierId();
                self.previousCarrierList = self.carrierList();
            }
            else if (self.carrierHasChanged(self.carrierList(), data.SelectedCarrierId)) {
                PubSub.publish(mcWeb.shipment.events.onChangedShipment, data);
                self.previousCarrierId = self.selectedCarrierId();
                self.previousCarrierList = self.carrierList();
            }
        };

        self.carrierHasChanged = function (newCarrierList, newSelectedCarrierId) {
            if (self.previousCarrierId !== newSelectedCarrierId)
                return true;
            if (self.previousCarrierList === null && newCarrierList !== null)
                return true;
            if (self.previousCarrierList !== null && newCarrierList === null)
                return true;
            if (self.previousCarrierList.length !== newCarrierList.length)
                return true;
            for (var i = 0; i < self.previousCarrierList.length; i++) {
                var previousCarrier = self.previousCarrierList[i];
                var currentCarrier = newCarrierList[i];
                if (previousCarrier.Id !== currentCarrier.Id)
                    return true;
                if (previousCarrier.Name !== currentCarrier.Name)
                    return true;
                if (previousCarrier.PrintPrice !== currentCarrier.PrintPrice)
                    return true;
            }
            return false;
        }
        
        this.useInsuranceProduct.subscribe(function (checked) {
            if (!self.showInsuranceProduct()) return true;

            self.showRefreshSpin(true);

            var data = { addProduct: checked }
            try {
                self.service.GetAction("SetInsuranceProduct", data).then(function (result) {
                    self.showRefreshSpin(false);
                    if (result == null || result.length < 1) return;
                    if (result.Success === false)
                        alert(result.Message);
                    PubSub.publish(mcWeb.cart.events.onChangedCart, "");
                });
            } catch (err) {
                console.log(err);
            }


            return true;
        });

        this.getPickupPointRegions = function () {
            if (!self.pickupPointEnabled()) return true;
            self.showRefreshSpin(true);

            self.service.GetAction("GetPickupPointRegions", null).then(function (result) {
                self.showRefreshSpin(false);

                if (result == null || result.length < 1) return;

                self.pickupPointRegionList(result);
                self.pickupPointRegion(self.pickupPointRegionList()[0].Region);
                self.pickupPointRegionId(self.pickupPointRegionList()[0].RegionId);
                if (result.length === 1) self.pickupPointSelectedRegion(self.pickupPointRegionId());
            });
            return true;
        }

        this.pickupPointSelectedRegion.subscribe(function (regionId) {
            if (regionId == null) return false;
            if (regionId === "") return false;
            if (self.selectedCarrierId == null) return false;

            self.showRefreshSpin(true);

            var data = { regionId: regionId }
            self.service.GetAction("GetPickupPointCustomers", data).then(function (result) {
                self.showRefreshSpin(false);

                if (result == null || result.length < 1) return;

                self.pickupPointCustomerList(result);
                self.pickupPointCustomername(self.pickupPointCustomerList()[0].Customername);
            });
            return true;
        });

        this.saveSelectedPickupPointCustomer = function (customerId, customerName, customerEmail) {
            if (customerId == null || customerName == null || customerEmail == null) return false;
            var data = { customerId: customerId, customerName: customerName, customerEmail: customerEmail }

            self.showRefreshSpin(true);
            self.service.GetAction("SaveSelectedPickupPointCustomer", data).then(function (result) {
                self.showRefreshSpin(false);
            });

            return true;
        }

        this.pickupPointSelectedCustomer.subscribe(function (selectedPickupPoint) {
            if (selectedPickupPoint == null) return false;
            if (self.selectedCarrierId == null) return false;

            var customername = "";
            var customerEmail = "";

            if (selectedPickupPoint.Customername != null) customername = selectedPickupPoint.Customername.trim();
            if (selectedPickupPoint.EmailAddress != null) customerEmail = selectedPickupPoint.EmailAddress.trim();

            self.saveSelectedPickupPointCustomer(selectedPickupPoint.CustomerId, customername, customerEmail);

            return true;
        });

        var setSelectedCarrier = function (data) {
            jQuery.each(data.CarrierList, function (index, obj) {
                if (obj.Id == data.SelectedCarrierId && (self.selectedCarrierName() !== obj.Name || self.selectedCarrierPrice() !== obj.PrintPrice)) {
                    var publishEvent = self.selectedCarrierName() !== undefined;

                    self.selectedCarrierName(obj.Name);
                    self.selectedCarrierPrice(obj.PrintPrice);

                    self.logistraPickupPointsForSelectedCarrier(obj.LogistraPickupPoints);
                    if (!self.selectedLogistraPickupPoint())
                        self.saveLogistraPickupPoint(null);

                    self.shipAdvisorDropPointsForSelectedCarrier(obj.ShipAdvisorDropPoints);
                    if (!self.selectedShipAdvisorDropPoint())
                        self.saveShipAdvisorDropPoint(null);

                    if (publishEvent)//no need upon first load
                        PubSub.publish(mcWeb.cartsmall.events.onChangedQuantityCartSmall, "");
                }
                else if (obj.Id == data.SelectedCarrierId) {
                    self.logistraPickupPointsForSelectedCarrier(obj.LogistraPickupPoints);
                    if (!self.selectedLogistraPickupPoint())
                        self.saveLogistraPickupPoint(null);

                    self.shipAdvisorDropPointsForSelectedCarrier(obj.ShipAdvisorDropPoints);
                    if (!self.selectedShipAdvisorDropPoint())
                        self.saveShipAdvisorDropPoint(null);
                }
            });
            self.getPickupPointRegions();
        }

        this.onChangedLogistraPickupPoint = function (context) {
            try {
                const id = context.Id;
                if (!id) return;
                self.selectedLogistraPickupPoint(id);
                const data = self.logistraPickupPointsForSelectedCarrier().find(obj => { return obj.Id === id });
                self.saveLogistraPickupPoint(data);

                // Frakt må oppdateres. Prisen kan være annen for valgt utleveringssted.
                PubSub.publish(mcWeb.shipment.events.reloadShipment);
            } catch (err) {
                console.log(err);
            }
        };

        this.saveLogistraPickupPoint = function (saveRequest) {
            self.showRefreshSpin(true);

            try {
                self.service.GetAction("SaveSelectedLogistraPickupPoint", saveRequest).then(function (result) {
                    self.showRefreshSpin(false);
                    if (result == null || result.length < 1) return;
                    if (result.Success === false)
                        alert(result.Message);
                });
            } catch (err) {
                console.log(err);
            }
        }

        this.onChangedShipAdvisorDropPoint = function (context) {
            try {
                const id = context.Id;
                if (!id) return;
                self.selectedShipAdvisorDropPoint(id);
                const data = self.shipAdvisorDropPointsForSelectedCarrier().find(obj => { return obj.Id === id });
                self.saveShipAdvisorDropPoint(data);

                // Frakt må oppdateres. Prisen kan være annen for valgt utleveringssted.
                PubSub.publish(mcWeb.shipment.events.reloadShipment);
            } catch (err) {
                console.log(err);
            }
        };

        this.saveShipAdvisorDropPoint = function (saveRequest) {
            self.showRefreshSpin(true);

            try {
                self.service.GetAction("SaveSelectedShipAdvisorDropPoint", saveRequest).then(function (result) {
                    self.showRefreshSpin(false);
                    if (result == null || result.length < 1) return;
                    if (result.Success === false)
                        alert(result.Message);
                });
            } catch (err) {
                console.log(err);
            }
        }

        //Subscribe to event
        this.saveSelectedCarrier = function (carrier) {
            self.showRefreshSpin(true);

            self.pickupPointSelectedCustomer(undefined);
            self.pickupPointSelectedRegion(undefined);
            self.pickupPointCustomerList.removeAll();

            self.selectedCarrierName(carrier.Name);
            self.selectedCarrierPrice(carrier.PrintPrice);

            var authenticationGuid = mcWeb.currentUser.getAuthenticationGUID();
            var email = mcWeb.loginCheckout.getEmail();
            carrier.PickupPoint = null;

            var data = {
                carrierItem: carrier,
                email: email,
                zipCode: null,
                isCheckout: self.isCheckout,
                authenticationGuid: authenticationGuid
            }

            self.service.PostAction("SaveSelectedCarrier", data).then(function (result) {
                self.showRefreshSpin(false);            
                
                PubSub.publish(mcWeb.shipment.events.onSelectedShipment, carrier);

                if (result !== null && result != undefined) {
                    PubSub.publish(mcWeb.events.customerRegistration.onChangedCustomerData, result.CustomerRegistration);
                    if (result.SelectedCarrierRemoved) {
                        PubSub.publish(mcWeb.shipment.events.reloadShipment, result.Carriers);
                    }
                    //result.HasLockedDeliveryAddress = true / false;
                }
            });
            return true;
        };

        PubSub.subscribe(mcWeb.shipment.events.onSelectedShipment, function (message, carrier) {
            if (!carrier)
                return;

            self.selectedCarrierName(carrier.Name);
            self.selectedCarrierPrice(carrier.PrintPrice);
        });

        this.showCarrierList = function () {
            self.showOnlyCarrierList(true);
        }

        PubSub.subscribe(mcWeb.cart.events.hasCartItems, function (message, data) {

            if (data != null) {
                self.hasCartItems(data); //was False
            }
        });

        PubSub.subscribe(mcWeb.shipment.events.reloadShipment, function (message, data) {
            self.load(data);
        });

        PubSub.subscribe(mcWeb.events.customerRegistration.onChangedCustomerData, function (message, data) {
            if (data == null)
                return

            if (data.useDifferentDeliveryAddress != null && data.useDifferentDeliveryAddress == true) {
                if (data.postnrDelivery != null && data.postnrDelivery != self.zipCode()) {
                    self.LoadZipCode(data.postnrDelivery);
                }

                self.adressDelivery((data.adressDelivery == null) ? "" : data.adressDelivery);
                self.adresstillegDelivery((data.adresstillegDelivery == null) ? "" : data.adresstillegDelivery);
                self.poststedDelivery((data.poststedDelivery == null) ? "" : data.poststedDelivery);
            }
            else {
                if (data.postnr != null && data.postnr != self.zipCode()) {
                    self.LoadZipCode(data.postnr);
                }

                self.adressDelivery((data.adress == null) ? "" : data.adress);
                self.adresstillegDelivery((data.adresstilleg == null) ? "" : data.adresstilleg);
                self.poststedDelivery((data.poststed == null) ? "" : data.poststed);
            }
        });

        PubSub.subscribe(mcWeb.events.customerRegistration.onChangedCity, function (message, city) {
            self.poststedDelivery((city == null || city.length < 1) ? '' : city);
        });

        PubSub.subscribe(mcWeb.events.customerRegistration.onChangedZipCode, function (message, data) {
            if (!data)
                return;

            var zipCode = data.zipCode;
            if (!zipCode)
                return;

            if (self.zipCode() != zipCode) {
                self.zipCodePrev(zipCode);
                self.zipCode(zipCode);
                self.load();
            }
        });

        PubSub.subscribe(mcWeb.payments.events.onSelectedPayment, function (message, paymentId) {
            if (paymentId != null) {
                self.service.GetAction("ShowCollectedDeliveryBasedOnPayment", { betBetId: paymentId }).then(function (result) {
                    if (result == 2) {
                        self.showCollectedDelivery(false);
                        self.useCollectedDelivery(true);
                    }
                    self.showCollectedDelivery((result === 1));
                });
            }
        });

        this.LoadZipCode = function (zipCode) {
            if (zipCode == null || zipCode.length < 3)
                return

            try {
                if ((zipCode.indexOf("*") > -1)) {
                    self.showCheckoutZipCode(false);
                    return;
                }

                self.showRefreshSpin(true);

                var data = { zipCode: zipCode };
                PubSub.publish(mcWeb.events.customerRegistration.onChangedZipCode, data);
                PubSub.publish(mcWeb.cart.events.onChangedCart, null);

            } catch (e) {
                stopUpdateIcon();
                console.error(e);
            }
        };

        this.shipmentInfo = function () {
            if (self.zipCode() != null && self.zipCode().indexOf('*') > -1) {
                return "";
            }

            var text = (self.postOffice() == null || self.postOffice().length < 1) ? "" : self.postOffice() + ' ';
            text += (self.zipCode() == null || self.zipCode().length < 1) ? "" : self.zipCode() + ' ';
            text += (self.poststedDelivery() == null || self.poststedDelivery().length < 1) ? "" : self.poststedDelivery() + ' ';

            return text;
        };

        /* NEW */
        this.onToggleCarrierTypes = function () {
            $('#carriers').slideToggle();
            self.carrierListVisible(!self.carrierListVisible());
        };

        this.isNumberKey = function (sender, e) {
            var key = (e.which) ? e.which : e.keyCode;
            if (key == 13) {
                document.activeElement.blur();
                return false;
            }
            return !(key > 31 && (key < 48 || key > 57));
        };

        self.zipCode.subscribe(function (zipCode) {

            if (self.zipCodePrev() == zipCode)
                return;

            self.poststedDelivery('');

            if (zipCode != null && zipCode.length > 3) {
                self.zipCodePrev(zipCode);
                self.LoadZipCode(zipCode);
            }
        });

        $('#qt-carrier-zipcode-i').popover({
            trigger: 'hover',
            title: $('#qt-carrier-zipcode-t').html(),
            content: $('#qt-carrier-zipcode-c').html(),
            placement: 'top',
            container: 'body'
        });

        $('#qt-coll-delivery-i').popover({
            trigger: 'hover',
            title: $('#qt-coll-delivery-t').html(),
            content: $('#qt-coll-delivery-c').html(),
            placement: 'top',
            container: 'body'
        });

        $('#qt-print-packing-i').popover({
            trigger: 'hover',
            title: $('#qt-print-packing-t').html(),
            content: $('#qt-print-packing-c').html(),
            placement: 'top',
            container: 'body'
        });

        $('#qt-insurance-i').popover({
            trigger: 'hover',
            title: $('#qt-insurance-t').html(),
            content: $('#qt-insurance-c').html(),
            placement: 'top',
            container: 'body'
        });

        ko.bindingHandlers.popoverShipping = {
            init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
                var node = $(element);
                self.popoverNode = node;
                var option = ko.utils.unwrapObservable(valueAccessor());
                var conId = option.contentid, titId = option.titleid, kn = "-kn";
                var contentkn = "<div id='" + conId + kn + "'>" + $('#' + conId).html() + "</div>";
                var titlekn = "<div id='" + titId + kn + "'>" + $('#' + titId).html() + "</div>";

                self.togglePopover = function () {
                    $(event.target.parentElement).popover('toggle');
                    var innerData = document.getElementById(conId);

                    ko.cleanNode(innerData);
                }

                node.popover({
                    title: titlekn,
                    content: contentkn,
                    html: option.html,
                    trigger: 'manual',
                    placement: function (context) {
                        var con = jQuery(context);
                        con.addClass(option.contentClass);

                        var module = $('body.mc-inline-editor');
                        if (module.length > 0)
                            return 'bottom';

                        con.on('mouseleave', function () {
                            node.popover('hide');
                            self.popoverOpen(false);
                            return true;
                        });
                        return 'bottom';
                    }
                });

                node.click(function () {

                    self.togglePopover();
                    self.popoverOpen(!self.popoverOpen());

                    if (self.inlineEditor && !!mcWeb.inlineEditor) {
                        mcWeb.inlineEditor.init(true);
                    }
                });
            }
        };

        this.formatPickupPointAddress = function (address, postalCode, city) {
            if (address === '') return "";
            return address + ', ' + postalCode + ' ' + city;
        };
    };
});
